<script setup lang="ts">
import {reactive, ref} from "vue";
import {SystemService, UserService} from "@/api/api.ts";
import {userUserStore} from "@/store/user.ts";
import {ElNotification} from "element-plus";
import {validatePhone} from "@/utils/common.ts";

const second = ref(60)
const isCountdown = ref(false);
const userStore = userUserStore()
const isShowing = ref(false)
let interval: NodeJS.Timeout | null = null;
const loginForm = reactive({
  name: "",
  phone: "",
  code: ""
})

const closeLoginDialog = () => {
  isShowing.value = false
}

const showLoginDialog = () => {
  isShowing.value = true
}

const onLogin = async () => {
  try {
    if (!loginForm.name) {
      return ElNotification.warning({
        message: "请输入姓名"
      })
    }
    if (!validatePhone(loginForm.phone)) {
      return ElNotification.warning({
        message: "请输入正确的手机号"
      })
    }
    if (!loginForm.code) {
      return ElNotification.warning({
        message: "请输入验证码"
      })
    }
    const res = await UserService.login({
      phone: loginForm.phone,
      code: loginForm.code,
      name: loginForm.name
    })
    if (res.data.code === 200) {
      closeLoginDialog()
      ElNotification.success({
        title: '登录成功',
        message: res.data.msg,
      })
      if (res.data.data) {
        userStore.setUser(res.data.data)
      }
    } else {
      console.warn("111")
      ElNotification.error({
        title: '登录失败',
        message: res.data.msg,
        type: 'error',
      })
    }
  } catch (err) {
    console.warn(err)
  }
}

const sendMsg = async () => {
  if (!validatePhone(loginForm.phone)) {
    return ElNotification.warning({
      message: "请输入正确的手机号"
    })
  }
  if (isCountdown.value) {
    return;
  }
  try {
    const res = await SystemService.sendCode({
      mobile: loginForm.phone,
    })
    if (res.data.code === 200) {
      isCountdown.value = true
      second.value = 60
      if (interval) {
        clearInterval(interval)
      }
      // 倒计时
      interval = setInterval(() => {
        second.value -= 1
        if (second.value == 1) {
          isCountdown.value = false
          // 倒计时结束，关闭倒计时
          if (interval) {
            clearInterval(interval)
          }
        }
      }, 1000)
      ElNotification.success({
        message: res.data.msg,
      })
    } else {
      ElNotification.error({
        message: res.data.msg,
      })
    }
  } catch (err) {
    console.warn(err)
  }
}

const onClose = () => {
  isShowing.value = false
  if (interval) {
    second.value = 60
    isCountdown.value = false
    clearInterval(interval)
  }
}

defineExpose({showLoginDialog, closeLoginDialog})
</script>

<template>
  <el-dialog @close="onClose" style="border-radius: 1.25rem;" width="35rem" v-model="isShowing" align-center
             :close-on-click-modal="false">
    <div class="mx-auto">
      <div class="text-center text-1.5em font-bold mb-2.5rem">登录</div>
    </div>
    <div class="mx-auto mt-3.5rem mb-4rem w-23.75rem">
      <div>
        <el-input class="w-full h-2.5rem mt-.875rem box-border"
                  placeholder="姓名" v-model="loginForm.name" maxlength="10"/>
      </div>
      <div>
        <el-input
            class="w-full h-2.5rem mt-.875rem box-border"
            placeholder="手机号" v-model="loginForm.phone" maxlength="11"/>
      </div>
      <div class="flex items-center mt-.875rem">
        <el-input class="rounded-r-0 w-16.125rem h-2.5rem box-border my-phone-input" placeholder="验证码"
                  v-model="loginForm.code" maxlength="6"/>
        <el-button class="my-send-btn" type="primary" style="width: 7.625rem; height: 2.5rem; background: #ff6600cc"
                   @click="sendMsg">
          {{ isCountdown ? `${second}秒后重发` : "获取验证码" }}
        </el-button>
      </div>
      <el-button
          round class="mt-.875rem" type="primary"
          style="width: 100%; height: 2.5rem; background: #ff6600cc"
          @click="onLogin">登录
      </el-button>
    </div>
    <div class="form-section-separator"></div>
  </el-dialog>
</template>

<style scoped>
.my-phone-input {
  --el-input-border-radius: 4px 0px 0px 4px;
}

.my-send-btn {
  --el-border-radius-base: 0 4px 4px 0;
}
</style>